// AP-101 FINAL · Impersonation banner + "Voltar ao Super Admin" button.
// Rendered globally when the current JWT was issued via /super/impersonate.
import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

function readImpersonation() {
  try {
    const raw = localStorage.getItem("jms_impersonating_tenant");
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.expires_at && new Date(data.expires_at).getTime() < Date.now()) {
      localStorage.removeItem("jms_impersonating_tenant");
      return null;
    }
    return data;
  } catch { return null; }
}

export default function ImpersonationBanner() {
  const [meta, setMeta] = React.useState(readImpersonation());
  React.useEffect(() => {
    const i = setInterval(() => setMeta(readImpersonation()), 30_000);
    return () => clearInterval(i);
  }, []);
  if (!meta) return null;
  const restore = () => {
    const original = localStorage.getItem("jms_super_return_token");
    if (!original) {
      toast.error("Token original perdido. Faça login novamente.");
      return;
    }
    localStorage.setItem("jms_token", original);
    localStorage.removeItem("jms_super_return_token");
    localStorage.removeItem("jms_impersonating_tenant");
    window.location.href = "/super/companies";
  };
  return (
    <div className="sticky top-0 z-50 bg-rose-600 text-white px-4 py-2 flex items-center justify-between shadow-lg" data-testid="impersonation-banner">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <AlertTriangle className="h-4 w-4 shrink-0 animate-pulse" />
        Você está administrando a empresa <b className="ml-1">{meta.name}</b>
        {meta.expires_at && (
          <span className="text-rose-100 text-xs ml-2 hidden md:inline">
            · até {new Date(meta.expires_at).toLocaleTimeString("pt-BR").slice(0, 5)}
          </span>
        )}
      </div>
      <Button size="sm" variant="secondary" onClick={restore}
        data-testid="impersonation-restore" className="bg-white text-rose-700 hover:bg-rose-50">
        <X className="h-3.5 w-3.5 mr-1" />Voltar ao Super Admin
      </Button>
    </div>
  );
}
